import { observable, action, computed, runInAction, makeObservable } from "mobx";
import * as Request from "superagent";

interface ResultsData {
  NumberOfPages?: number;
  TotalItemCount?: number;
  ItemCount?: number;
  CurrentPage?: number;
  Hits?: SearchContent[];
  PageTypes?: { [key: string]: number };
}

interface SearchContent {
  Heading?: string;
  Description?: string;
  Url?: string;
  ImageSrc?: string;
  ReadingTime?: string;
  PageType: string;
  PublishedDate?: Date;
}

const username = "subaruteam";
const password = "Carrot!";

const removeHtmlTags = (str: string): string => {
  return str.replace(/<[^>]*>/g, "");
};

export default class SearchPageModel {
  constructor() {
    makeObservable(this);
  }
  @observable response: ResultsData | null = null;
  @observable responsev2: string[] | null = null;
  query: string = "";

  @action reset = () => {
    this.response = null;
    this.responsev2 = null;
  };

  @action
  fetchSearchSuggestions = (query: string, baseUrl: string) => {
    this.query = query;
    const url = `${baseUrl}/api/search-wo?query=${query}&itemsPerPage=12&page=1`;
    const urlv2 = `/api/search-wo/suggest?query=${query}&Index=Default_query_suggestions`;

    Request.get(urlv2)
      .auth(username, password)
      .then(
        (response) => {
          runInAction(() => {
            this.responsev2 = JSON.parse(response.text);
            if (!this.responsev2 || this.responsev2.length === 0) {
              Request.get(url)
                .auth(username, password)
                .then(
                  (response) => {
                    runInAction(() => {
                      this.response = JSON.parse(response.text);
                    });
                  },
                  (error) => {
                    runInAction(() => {
                      console.log(
                        `An error occurred loading keyword suggestions ${error}`
                      );
                    });
                  }
                );
            }
          });
        },
        (error) => {
          runInAction(() => {
            console.log(
              `An error occurred loading keyword suggestions ${error}`
            );
          });
        }
      );
  };

  @computed
  get suggestions(): string[] {
    if (this.responsev2 && this.responsev2.length > 0) {
      return this.responsev2
        .map((heading) => {
          let cleanHeading = removeHtmlTags(heading);
          cleanHeading = cleanHeading.slice(0, 60);
          return cleanHeading;
        })
        .filter((heading) => heading);
    } else if (this.response && this.response.Hits) {
      return this.response.Hits.slice(0, 10)
        .map((hit) => {
          let heading = hit.Heading
            ? removeHtmlTags(hit.Heading.split("|")[0])
            : "";
          heading = heading.slice(0, 60);
          return heading;
        })
        .filter((heading) => heading);
    } else {
      return [];
    }
  }
}
